import { provideChameleonDesignSystem } from '../provideChameleonDesignSystem';
import { chameleonSvg } from '../Svg/Svg.definition';
import { chameleonChip } from './Chip.definition';
import { chameleonAvatar } from '../Avatar/Avatar.definition';
export function registerCustom(prefix, node) {
    return provideChameleonDesignSystem({ prefix, node }).register(chameleonChip({ prefix }), chameleonSvg({ prefix }), chameleonAvatar({ prefix }));
}
